import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, userRole } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      // Role-based redirect handled by useEffect after auth state updates
    } catch (err) {
      setError('Ungültige E-Mail oder Passwort.');
    }
    setLoading(false);
  }

  // Redirect after login based on role
  React.useEffect(() => {
    if (userRole === 'admin') navigate('/admin');
    else if (userRole === 'club') navigate('/club');
  }, [userRole, navigate]);

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <h1>RPE System</h1>
          <p>Subjektives Belastungsempfinden</p>
        </div>
        {error && <div className="error-msg">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>E-Mail</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="ihre@email.com"
              required
            />
          </div>
          <div className="form-group">
            <label>Passwort</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          <button
            type="submit"
            className="btn-primary"
            style={{ width: '100%', padding: '14px', fontSize: '16px' }}
            disabled={loading}
          >
            {loading ? 'Anmelden...' : 'Anmelden'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '12px', color: '#888' }}>
          RPE Monitoring System © 2024
        </p>
      </div>
    </div>
  );
}
